import React, { useState, useEffect } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import {
  Box,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Tooltip,
  Checkbox,
  FormControlLabel,
} from "@mui/material"
import Alert from "@mui/material/Alert"
import Swal from "sweetalert2"
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import BackIcon from "../../../components/BackIcon"
import GrabarIcon from "../../../assets/iconos/Grabar.ico"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))
const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const CrearMotivo = () => {
  const navigate = useNavigate()

  // Valores por defectos para los comboboxes y el check
  const Estados = [
    { value: "A", description: "ACTIVO" },
    { value: "I", description: "INACTIVO" },
  ]
  const Tipos = [
    { value: "SOLING", description: "INGRESO" },
    { value: "SOLEGR", description: "EGRESO" },
  ]

  // Estados para manejaar el formulario de opciones
  // cuando llame a las funciones set, se actualizara el valor de los otros campos y se re renderiza
  const [codigo, setCodigo] = useState("")
  const [descripcion, setDescripcion] = useState("")
  const [estadoMotivo, setEstadoMotivo] = useState(Estados[0])
  const [tipoMotivo, setTipoMotivo] = useState(Tipos[0])

  const { mutateAsync: createMotivo, isPending: isCreatingMotivo } = useCreateMotivo()

  function useCreateMotivo() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (motivo) => {
        // send api update request here
        // send api update request here
        const options = {
          method: "POST",
          body: JSON.stringify(motivo),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json", options.body)
        let response = await fetchwrapper(`/Motivos/createMotivo`, options)

        response = response.json()
        console.log(response)
        return response
      },
      // client side optimistic update
      onMutate: (newMotivo) => {
        console.log(newMotivo, "onmutate")
        queryClient.setQueryData(["Motivo", newMotivo.id], (prevMotivo) => ({
          ...newMotivo,
        }))
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const motivo = {
        codigoMotivo: codigo,
        descripcionMotivo: descripcion,
        tipoMotivo: tipoMotivo.value,
        estadoMotivo: estadoMotivo.value,
      }

      await createMotivo(motivo)
      Swal.fire({
        icon: "success",
        title: "Operación exitosa",
        text: "Se pudo crear el Motivo",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/home/dashboard/Motivos") // Navegar a la ruta especificada
        }
      })
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo crear el motivo",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/home/dashboard/Motivos") // Navega de vuelta cuando se cierre el SweetAlert
      })
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Motivos de Solicitud</b>
        </div>
        <Box className={StyledRoot}>
          <form onSubmit={handleSubmit}>
            <Tooltip title="Grabar">
              <Button type="submit" color="primary" sx={{ marginTop: "15px" }}>
                <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
              </Button>
            </Tooltip>
            <TextField
              label="Código"
              margin="normal"
              fullWidth
              value={codigo}
              required
              onChange={(e) => setCodigo(e.target.value)}
              inputProps={{ maxLength: 3 }}
            />
            <TextField
              label="Descripción"
              margin="normal"
              fullWidth
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              required
            />
            <div>
              <InputLabel id="estadoMotivosCB" sx={{ paddingBlock: "15px", paddingLeft: "5px" }}>
                Estado del motivo
              </InputLabel>
              <Select
                fullWidth
                disabled
                labelId="estadoMotivosCB"
                value={estadoMotivo.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const motivoestado = Estados.find((estado) => estado.value === selectedValue)
                  setEstadoMotivo(motivoestado)
                  //   clearAll(tipoPregunta)
                }}
              >
                {Estados.map((estado) => (
                  <MenuItem key={estado.value} value={estado.value}>
                    {estado.description}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div>
              <InputLabel id="tipoMotivosCB" sx={{ paddingBlock: "15px", paddingLeft: "5px" }}>
                Tipo del motivo
              </InputLabel>
              <Select
                fullWidth
                labelId="tipoMotivosCB"
                value={tipoMotivo.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const motivotipo = Tipos.find((tipo) => tipo.value === selectedValue)
                  setTipoMotivo(motivotipo)
                  //   clearAll(tipoPregunta)
                }}
              >
                {Tipos.map((tipo) => (
                  <MenuItem key={tipo.value} value={tipo.value}>
                    {tipo.description}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </form>
        </Box>
        <CustomBackdrop isLoading={isCreatingMotivo} />
      </div>
    </ThemeProvider>
  )
}

export default CrearMotivo
